// extracted by mini-css-extract-plugin
export default {"loading":"index_loading_DdyEf","logo":"index_logo_sT9jP","progress_box":"index_progress_box_b-eJm","progress":"index_progress_EY4Xf","txt":"index_txt_9lbPx"};